import LandingFrame from './LandingFrame';
import vendorHtml from '../../../public/landing/vendor.html?raw';

const Vendor = () => <LandingFrame html={vendorHtml} title="소셜듀오 · 제조사" />;

export default Vendor;
